import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=20ebbc52&"
import script from "./Sponsor.vue?vue&type=script&lang=js&"
export * from "./Sponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ebbc52')) {
      api.createRecord('20ebbc52', component.options)
    } else {
      api.reload('20ebbc52', component.options)
    }
    module.hot.accept("./Sponsor.vue?vue&type=template&id=20ebbc52&", function () {
      api.rerender('20ebbc52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Sponsors/Sponsor.vue"
export default component.exports